/*export const environment = {
    production: false,
    SUrlgApi: "https://localhost:44313/api/v1/",
    sUrlAuth: "http://localhost:5286/api/"
};*/
export const environment = {
    production: false,
    //SUrlgApi: "https://localhost:44313/api/v1/",
    //sUrlNomina: "https://localhost:44351/api/",
    sUrlNomina: "https://beta.apinom.sw-hmp.com/api/",
    SUrlgApi: "https://beta.apirestfulnetcore.sw-hmp.com/api/v1/",
    sUrlAuth: "https://beta.apiAuth.sw-hmp.com/api/",
    //sUrlAuth: "https://localhost:44351/api/",
    sUrlRecibo: "https://beta.recibonomina.sw-hmp.com/api/v1/",
    sUrlGd: "https://beta.gestiondispositivos.sw-hmp.com/api/v1/",
};

